import { handleActions } from 'redux-actions';
import { TOGGLE_POSITION_OVERLAY, TOGGLE_MOBILE_HEADER_SEARCH } from './const';

const root = document.getElementById('root');
const pageTypeId = (root && root.dataset.pageTypeId) || '';
const initialState = {
	pageTypeId,
	isPending: true,
	hasActivePositionOverlay: false,
	documentTitle: 'DEFAULT',
	isVisibleMobileHeaderSearch: false,
};

export const appReducer = handleActions(
	{
		[TOGGLE_POSITION_OVERLAY.ACTION]: (state, { payload }) => ({
			...state,
			hasActivePositionOverlay: payload,
		}),
		[TOGGLE_MOBILE_HEADER_SEARCH]: (state) => ({
			...state,
			isVisibleMobileHeaderSearch: !state.isVisibleMobileHeaderSearch,
		}),
	},
	initialState,
);
